import React, { useEffect, useState, useCallback } from 'react';
import Card from '../../components/ui/Card';
import Btn from '../../components/ui/Btn';
import Badge from '../../components/ui/Badge';
import { Input } from '../../components/ui/Input';
import FuncionarioForm from './FuncionarioForm';
import { funcionariosApi } from '../../api/rh';
import { COLORS } from '../../theme';

const STATUS_TOM = { ativo: 'sucesso', ferias: 'info', afastado: 'aviso', demitido: 'perigo' };
const STATUS_LABEL = { ativo: 'Ativo', ferias: 'Férias', afastado: 'Afastado', demitido: 'Demitido' };

export default function FuncionariosList() {
  const [funcionarios, setFuncionarios] = useState([]);
  const [busca, setBusca] = useState('');
  const [funcionarioAbertoId, setFuncionarioAbertoId] = useState(undefined);

  const carregar = useCallback(() => {
    funcionariosApi.listar(busca ? { busca } : {}).then(setFuncionarios).catch(() => {});
  }, [busca]);

  useEffect(() => { carregar(); }, [carregar]);

  if (funcionarioAbertoId !== undefined) {
    return (
      <FuncionarioForm
        funcionarioId={funcionarioAbertoId}
        onVoltar={() => { setFuncionarioAbertoId(undefined); carregar(); }}
        onSalvo={carregar}
      />
    );
  }

  return (
    <div>
      <Card style={{ padding: 0, overflow: 'hidden' }}>
        <div style={{ padding: 14, borderBottom: `1px solid ${COLORS.border}`, display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12 }}>
          <Input placeholder="Buscar por nome, CPF ou cargo..." value={busca}
            onChange={e => setBusca(e.target.value)} style={{ width: 360 }} />
          <Btn onClick={() => setFuncionarioAbertoId(null)}>+ Novo Funcionário</Btn>
        </div>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ textAlign: 'left', background: COLORS.bg }}>
              <th style={{ padding: 10 }}>Nome</th>
              <th style={{ padding: 10 }}>Empresa</th>
              <th style={{ padding: 10 }}>Cargo</th>
              <th style={{ padding: 10 }}>Admissão</th>
              <th style={{ padding: 10 }}>Status</th>
            </tr>
          </thead>
          <tbody>
            {funcionarios.map(f => (
              <tr key={f.id} onClick={() => setFuncionarioAbertoId(f.id)}
                style={{ borderTop: `1px solid ${COLORS.border}`, cursor: 'pointer' }}>
                <td style={{ padding: 10 }}>{f.nome}</td>
                <td style={{ padding: 10 }}>{f.empresa_nome || '-'}</td>
                <td style={{ padding: 10 }}>{f.cargo || '-'}</td>
                <td style={{ padding: 10 }}>{f.data_admissao ? new Date(f.data_admissao).toLocaleDateString('pt-BR') : '-'}</td>
                <td style={{ padding: 10 }}>
                  <Badge tom={STATUS_TOM[f.status] || 'info'}>{STATUS_LABEL[f.status] || f.status}</Badge>
                </td>
              </tr>
            ))}
            {funcionarios.length === 0 && (
              <tr><td colSpan={5} style={{ padding: 20, textAlign: 'center', color: COLORS.textMid }}>Nenhum funcionário cadastrado ainda.</td></tr>
            )}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
